export default __webpack_public_path__ + "static/media/NSC_colorido.67d194f7.png";